import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Footer.module.css';

function Footer() {
  const { t } = useTranslation();
  const baseUrl = process.env.PUBLIC_URL || '';

  return (
    <footer className={styles.footer}>
      <div className={styles.columns}>
        <div className={`${styles.col} ${styles['col-logo']}`}>
          <a href="/" className={styles.logo}>
            <img src={`${baseUrl}/scooter-logo.png`} alt="Bird Motorbike - Scooter rental Phuket" />
            <span>Bird Motorbike</span>
          </a>
          <p className={styles.description}>
            {t('footer.description')}
          </p>
        </div>
        <div className={styles.col}>
          <h4>{t('footer.quickLinks')}</h4>
          <a href="#scooters">{t('nav.ourScooters')}</a>
          <a href="#why-choose-us">{t('nav.whyChooseUs')}</a>
          <a href="#how-it-works">{t('nav.howItWorks')}</a>
          <a href="#pricing">{t('nav.pricing')}</a>
          <a href="#delivery">{t('nav.delivery')}</a>
          <a href="#reviews">{t('nav.reviews')}</a>
          <a href="#faq">{t('nav.faq')}</a>
        </div>
        <div className={styles.col}>
          <h4>{t('footer.contactUs')}</h4>
          <a href="https://wa.me/66943672385">WhatsApp: +66 94 367 2385</a>
          <p>Kathu, Phuket, Thailand</p>
        </div>
        <div className={styles.col}>
          <h4>{t('footer.businessHours')}</h4>
          <p>{t('footer.openDaily')}</p>
          <p>{t('footer.hours')}</p>
        </div>
      </div>
      <div className={styles.copyright}>
        © {new Date().getFullYear()} {t('footer.copyright')}
      </div>
    </footer>
  );
}

export default Footer;
